import { useApi, useWorkspace } from '~/contexts';
import { useField, useIsMounted } from '~/hooks';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import AutoComplete from './AutoComplete';
import FieldControl from './FieldControl';

function TimesheetAttestationSelect({ value, initialValue, shouldAutoSelect = false, ...props }) {
  const api = useApi();
  const isMounted = useIsMounted();
  const { workspace } = useWorkspace();
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [autoSelect, setAutoSelect] = useState(false);

  const handleSearch = useCallback(
    async (q) => {
      const { data } = await api.www
        .workspaces(workspace.id)
        .timesheetAttestations()
        .get({ q, isActive: true, include: initialValue ? initialValue.id : undefined, size: 1000 });

      return data;
    },
    [workspace.id, initialValue, api],
  );

  const refreshDefaultOptions = useCallback(async () => {
    const data = await handleSearch('');
    if (!isMounted.current) return;
    setDefaultOptions(data);
    setAutoSelect(data?.length > 0);
  }, [handleSearch, isMounted]);

  useEffect(() => {
    refreshDefaultOptions();
  }, [refreshDefaultOptions]);

  useEffect(() => {
    if (!autoSelect) {
      return;
    }
    setAutoSelect(false);

    if (!shouldAutoSelect || defaultOptions.length !== 1 || value || !_.isFunction(props.onChange)) {
      return;
    }

    props.onChange({ target: { name: props.name, value: defaultOptions[0] } });
  }, [autoSelect, shouldAutoSelect, defaultOptions, value, props]);

  return (
    <AutoComplete
      onSearch={handleSearch}
      value={value}
      displayText={value ? value.name : ''}
      defaultOptions={defaultOptions}
      renderOption={(option) => option.name}
      {...props}
    />
  );
}

function FieldTimesheetAttestationSelect(props) {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;

  return (
    <FieldControl error={error}>
      <TimesheetAttestationSelect {...field} {...props} />
    </FieldControl>
  );
}

export default TimesheetAttestationSelect;
export { FieldTimesheetAttestationSelect };
